import script from "./ConstructionInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConstructionInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ConstructionInfo.vue?vue&type=style&index=0&id=3b54be91&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b54be91"]])

export default __exports__